import React from "react";
import { MissionSubCard, MissionSubCardHorizontalDivider } from "./MissionLayoutComponents";
import { useAlert } from 'react-alert';

import Button from "../../common_components/Button";
import Timeline from "./Timeline";


import MissionUserListAPI from "../../../api/api_calls/MissionUserListAPI";

function MissionInReview({ mission, userMissionState, refreshMissionStatus }) {

    return (
        <MissionSubCard>
            <Timeline mission={mission} userMissionState={userMissionState} />
            <MissionSubCardHorizontalDivider showMobile={true} />
            <div className="mission-in-review-container">
                The researchers for this mission will review your profile and get back to you shortly.
            </div>
        </MissionSubCard>
    )
}

export default MissionInReview;